import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import * as cssVariable from 'cssVariables';

import { injectStyles } from 'injectStyles';

class InfoScreen extends PureComponent {
  static defaultProps = {
    image: '',
    title: '',
    text: '',
  };

  static propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    classes: PropTypes.object.isRequired,
  };

  render() {
    const { image, title, text, classes } = this.props;

    return (
      <div className={classes.wrapper}>
        {image && <img className={classes.image} src={image} alt={title || 'tv-connect-info-image'} />}
        {title && <div className={classes.title}>{title}</div>}
        {text && <div className={classes.text}>{text}</div>}
      </div>
    );
  }
}

const styles = (theme) => ({
  wrapper: {
    display: 'flex',
    width: '100%',
    maxWidth: 450,
    height: 'auto',
    flexDirection: 'column',
    alignItems: 'center',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
    flexShrink: 0,
  },
  title: {
    fontSize: 27,
    fontWeight: cssVariable.fontWeights.bold,
    margin: 15,
  },
  text: {
    fontSize: cssVariable.fontSizes.medium,
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    image: {
      maxWidth: 'calc(100% + 70px)',
    },
    title: {
      margin: 25,
    },
  },
});

export default injectStyles(styles)(InfoScreen);
